import Category from '../model/Category';
import ApiConnector from '../connector/ApiConnector';
import ArticleRepository from '../repository/ArticleRepository';
import Article from '../model/Article';
import MenuRepository from './MenuRepository';
import PriceItem from '../model/PriceItem';
import ArticleMarshaller from '../model/ArticleMarshaller';

export default class CategoryRepository {
    private static categories:Array<Category>;
    private apiConnector:ApiConnector;
    private articleRepository:ArticleRepository;
    private menuRepository:MenuRepository;


	constructor() {
        this.apiConnector = new ApiConnector();
        this.articleRepository = new ArticleRepository();
        this.menuRepository = new MenuRepository();
	}


    getAll() : Promise<Category[]> {
        if (CategoryRepository.categories === undefined) {
            return this.menuRepository.getMenu().then( (json:any) => {
                CategoryRepository.categories = []

                this.addCategorieFromResponse(json,"Aktionen");
                this.addCategorieFromResponse(json,"Pizzen");
                this.addCategorieFromResponse(json,"Pasta");
                this.addCategorieFromResponse(json,"Salate");
                this.addCategorieFromResponse(json,"Pizzabroetchen");
                this.addCategorieFromResponse(json,"Klassiker");
                this.addCategorieFromResponse(json,"Snacks");


                return CategoryRepository.categories
            })
        }
        
        return new Promise(resolve => {
            resolve(CategoryRepository.categories);
        })
        
    }

    private addCategorieFromResponse(json:any,name:string) {

        let categorieJson = json[name];
        let items:any = [];
        categorieJson.forEach( (item : any) => {
            items.push(new ArticleMarshaller(item).toModel());
        });
        CategoryRepository.categories.push(new Category(name,items))
    }

    private createCategoryPromises(menu: any) {
        console.log(menu);
        let categoryKeys = Object.getOwnPropertyNames(menu.kategorien);
        let categoryPromises: Array<Promise<Category>> = [];
        categoryKeys.forEach(key => {
            let categoryObject = menu.kategorien[key];
            if (categoryObject.produkte) {
                this.addProducts(categoryObject, categoryPromises);
            }
        });
        return categoryPromises;
    }

    private addProducts(categoryObject: any, categoryPromises: Promise<Category>[]) {
        let articlePromises:Array<Promise<Article>> = [];
        categoryObject.produkte.forEach((articleId: any) => {
            articlePromises.push(this.articleRepository.findById(articleId));
        });
        categoryPromises.push(Promise.all(articlePromises).then(articles => {
            return new Category(categoryObject.Name, articles);
        }));
    }

    private buildArticleFromResponseItem(item : any) {
        let priceItems: Array<PriceItem> = [];
        Object.getOwnPropertyNames(item.prices).forEach(element => {
            priceItems.push(new PriceItem(element,item.prices[element]))
        });
        return new Article(item.title,priceItems,item.starorder,item.number,this.stripIcon(item.icon),item.ingredients)
    }

    private stripIcon(path : string) {
        let icon = path.replace("/images/","")
        icon = icon.replace(".png", "")
        return icon
    }
}